import styled from "styled-components";
import theme from "../../../theme";

export const OvercomeChallengesContainer = styled.div`
  margin-bottom: 96px !important;
  @media (max-width: 992px) {
    margin-bottom: 96px !important;
  }
  @media (max-width: 480px) {
    margin-bottom: 72px !important;
  }
`;

export const OvercomeDescription = styled.div`
  max-width: 800px;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 57px;
  margin-top: 30px;
  ul {
    padding-left: 25px;
    list-style-type: decimal;
    margin-bottom: 40px;
  }
  li a {
    color: ${theme.black};
  }
  li a:hover {
    color: ${theme.cyan};
    text-decoration: underline;
  }
  h3 {
    max-width: 659px;
    font-size: 40px;
    line-height: 52px;
    margin-bottom: 36px;

    @media (max-width: 768px) {
      font-size: 34px;
      line-height: 42px;
    }
    @media (max-width: 480px) {
      font-size: 30px;
      line-height: 42px;
    }
    @media (max-width: 380px) {
      font-size: 24px;
      line-height: 34px;
    }
  }

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 32px;
  }
`;
